const throttle = (func, limit) => {
    let inThrottle;
    return function () {
        const args = arguments;
        const context = this;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(function () {
                inThrottle = false;
            }, limit);
        }
    };
}
/**
 * Checks if a URL is relative - prevent url spoofing
 * @param {string} url - url to check
 * @returns {boolean} - true if relative URL
 */
const isRelativeUrl = function (url) {
    return typeof url === 'string' && url.startsWith('/') && !url.startsWith('//');
}

const applyUrlParameter = function (urlString, parameterName, parameterValue) {
    if (!urlString || !parameterName) {
        return urlString;
    }
    var url;
    try {
        url = new URL(urlString);
    } catch (e) {
        return urlString;
    }
    url.searchParams.set(parameterName, parameterValue);
    return url.toString();
}

/**
 * @function appendParamToURL
 * @description appends the parameter with the given name and value to the given url and returns the changed url
 * @param {string} url the url to which the parameter will be added
 * @param {string} name the name of the parameter
 * @param {string} value the value of the parameter
 * @returns {string|null} - URL with parameter
 */
const appendParamToURL = function (url, name, value) {
    if (!url || !name) {
        return url;
    }
    // quit if the param already exists
    if (url.indexOf(name + '=') !== -1) {
        return url;
    }
    var separator = url.indexOf('?') !== -1 ? '&' : '?';
    return url + separator + name + '=' + encodeURIComponent(value);
}

/**
 * @function isGpcEnabled
 * @description Detects whether the browser has an active Global Privacy Control (GPC) opt-out signal
 * by evaluating navigator.globalPrivacyControl, per https://globalprivacycontrol.org/implementation
 * @returns {boolean} - true only when navigator.globalPrivacyControl is strictly true
 */
const isGpcEnabled = function () {
    return typeof navigator !== 'undefined' && navigator.globalPrivacyControl === true;
}


module.exports = { throttle, isRelativeUrl, applyUrlParameter, appendParamToURL, isGpcEnabled };